import React from "react";
import { createBrowserRouter } from "react-router-dom";

//
// !!!!!!!!!!!!!!! ПОМНИ !!!!!!!!!!!!!!!!
// TODO: название каждого элемента роутера должно оканчиваться на слово Screen
// TODO: внутри ...Screen должен содержать страницы обернутые в Layout
//
import { AppLayout, commonInfoLoader } from "@/App";
import CkassaBlacklistScreen from "@/screens/CkassaBlacklist";
import MarketForeignInvoiceScreen from "@/screens/MarketForeignInvoice";
import MarkerPromocodeScreen from "@/screens/MarketPromocode";
import MarketSteamGiftOrderScreen from "@/screens/MarketSteamGiftOrder";
import ModerateMicroreviewScreen from "@/screens/Moderate/MicroReviews";
import ModerateMicroreviewComplaintsScreen from "@/screens/Moderate/MicroreviewComplaints";
import AccountScreen from "@screens/Admin/AccountScreen";
import ActionLogScreen from "@screens/Admin/ActionLogScreen";
import DevelopersEmailScreen from "@screens/Admin/DevelopersEmailScreen";
import EventGenerateSerialsScreen from "@screens/Admin/EventGenerateSerialsScreen";
import EventGroupListScreen from "@screens/Admin/EventGroupScreen";
import EventListScreen from "@screens/Admin/EventListScreen";
import EventNewsletterHistoryItemScreen from "@screens/Admin/EventNewsletterHistoryItemScreen";
import EventNewsletterHistoryScreen from "@screens/Admin/EventNewsletterHistoryScreen";
import SchemaConfigurationScreen from "@screens/Admin/EventSchemaConfiguration";
import SchemeItemListScreen from "@screens/Admin/EventSchemeItemListScreen";
import SchemeListScreen from "@screens/Admin/EventSchemeListScreen";
import EventSelectionItemAddScreen from "@screens/Admin/EventSelectionItemAddScreen";
import EventSelectionItemEditScreen from "@screens/Admin/EventSelectionItemEditScreen";
import EventSelectionItemListScreen from "@screens/Admin/EventSelectionItemListScreen";
import EventSendNewsletterScreen from "@screens/Admin/EventSendNewsletterScreen";
import EventSendSerialsScreen from "@screens/Admin/EventSendSerialsScreen";
import EventSettingsScreen from "@screens/Admin/EventSettingsScreen";
import LandingAddGamesScreen from "@screens/Admin/LandingAddGamesScreen";
import LandingBlockGameEditScreen from "@screens/Admin/LandingBlockGameEditScreen";
import LandingBlockGamesScreen from "@screens/Admin/LandingBlockGamesScreen";
import BlockSettingsScreen from "@screens/Admin/LandingBlockSettingsScreen";
import LandingCTBlockScreen from "@screens/Admin/LandingCTBlockScreen";
import LandingCTBlockSettingsScreen from "@screens/Admin/LandingCTBlockSettingsScreen";
import LandingCTEditScreen from "@screens/Admin/LandingCTEditScreen";
import LandingCTItemEditScreen from "@screens/Admin/LandingCTItemEditScreen";
import LandingCTItemsScreen from "@screens/Admin/LandingCTItemsScreen";
import LandingCTList from "@screens/Admin/LandingCTList";
import LandingScreen from "@screens/Admin/LandingScreen";
import PocketsInfoEditScreen from "@screens/Admin/Pockets/PocketsInfoEdit";
import PocketsItemEditScreen from "@screens/Admin/Pockets/PocketsItemEdit";
import PocketsReactListScreen from "@screens/Admin/Pockets/PocketsList";
import PocketsReactListItemsScreen from "@screens/Admin/Pockets/PocketsListItems";
import UpcomingReleasesScreen from "@screens/Admin/UpcomingReleasesScreen";
import DevelopersDashboardScreen from "@screens/Dashboard";
import DeveloperListScreen from "@screens/Developer/List";
import { DeveloperRegisterScreen, DeveloperRejectScreen } from "@screens/Developer/Register";
import DeveloperScreen, { developerCommonInfoLoader } from "@screens/Developer/Screen";
import ErrorPage from "@screens/ErrorPage";
import FinStatementsScreen from "@screens/FinStatements/Screen";
import GameCreateScreen from "@screens/Game/Create";
import GameListScreen from "@screens/Game/List";
import GameScreen, { gameCommonInfoLoader } from "@screens/Game/Screen";
import GameCenterScreen from "@screens/GameCenter/Screen";
import MarketBukaScreen from "@screens/MarketBukaScreen";
import MarketEnazaScreen from "@screens/MarketEnazaScreen";
import MarketErrorScreen from "@screens/MarketError";
import MarketOrderScreen from "@screens/MarketOrder";
import MarketPaymentsScreen from "@screens/MarketPayments";
import MarketPlatformScreen from "@screens/MarketPlatform";
import MarketSalesScreen from "@screens/MarketSales";
import MarketSerialsScreen from "@screens/MarketSerials";
import MerchantSetScreen from "@screens/MerchantSetScreen";
import ModerateChatScreen from "@screens/Moderate/Chat";
import ModerateCommentsScreen from "@screens/Moderate/Comments";
import ModerateCommunityScreen from "@screens/Moderate/Community";
import ModerateProfilePostsScreen from "@screens/Moderate/ProfilePosts";
import BasicPromoModerationScreen from "@screens/Moderation/BasicPromo";
import DocumentsModerationScreen from "@screens/Moderation/Documents";
import EventModerationScreen from "@screens/Moderation/Event";
import FeaturingModerationScreen from "@screens/Moderation/Featuring";
import GameModerationScreen from "@screens/Moderation/Game";
import MarketSerialsModerationScreen from "@screens/Moderation/MarketSerials";
import PrModerationScreen from "@screens/Moderation/Pr";
import ProjectTransferModerationScreen from "@screens/Moderation/ProjectTransfer";
import NotFound from "@screens/NotFound";
import NoticeScreen from "@screens/Notice";
import PublisherScreen from "@screens/Publisher";
import DevelopersReportScreen from "@screens/Statements/DevelopersReport";
import GamesReportScreen from "@screens/Statements/GamesReport";
import TagScreen from "@screens/Tag";
import TouAcceptScreen from "@screens/TouAccept";
import TranslateScreen from "@screens/TranslateScreen";

export const AppRouter = createBrowserRouter([
    {
        id: "commonInfo",
        path: "/dev/",
        loader: commonInfoLoader,
        element: <AppLayout />,
        errorElement: <ErrorPage />,
        children: [
            {
                path: "*",
                element: <NotFound />,
            },
            { path: "translate/", element: <TranslateScreen /> },
            { path: "tou_accept/", element: <TouAcceptScreen /> },
            { path: "dashboard/:dash_type/", element: <DevelopersDashboardScreen /> },
            {
                path: "developers/",
                children: [
                    { path: "", element: <DeveloperListScreen /> },
                    { path: "register/", element: <DeveloperRegisterScreen /> },
                    { path: "reject/", element: <DeveloperRejectScreen /> },
                    {
                        id: "developerCommonInfo",
                        path: ":developerId/",
                        loader: developerCommonInfoLoader,
                        children: [
                            { path: "", element: <DeveloperScreen screen="reroute" /> },
                            { path: "app_form/", element: <DeveloperScreen screen="app_form" /> },
                            { path: "contact_info/", element: <DeveloperScreen screen="contact_info" /> },
                            { path: "accounts/", element: <DeveloperScreen screen="accounts" /> },
                            { path: "orders/", element: <DeveloperScreen screen="orders" /> },
                            { path: "send_letter/", element: <DeveloperScreen screen="send_letter" /> },
                            { path: "payment_info/:tab/", element: <DeveloperScreen screen="payment_info" /> },
                            { path: "technical_info/", element: <DeveloperScreen screen="technical_info" /> },
                            { path: "mytracker/", element: <DeveloperScreen screen="mytracker" /> },
                            { path: "moderator_comments/", element: <DeveloperScreen screen="moderator_comments" /> },
                            { path: "mytracker/", element: <DeveloperScreen screen="mytracker" /> },
                            { path: "statistics/:kind/", element: <DeveloperScreen screen="statistics" /> },
                            {
                                path: "projects_transfer/:kind/",
                                element: <DeveloperScreen screen="projects_transfer" />,
                            },
                            {
                                path: "counterparty_docs/",
                                element: <DeveloperScreen screen="counterparty_docs" />,
                            },
                            {
                                path: "counterparty_docs/:id/",
                                element: <DeveloperScreen screen="counterparty_docs" />,
                            },
                            { path: "publishers/", element: <DeveloperScreen screen="publishers" /> },
                            { path: "publishers/:id/", element: <DeveloperScreen screen="publishers" /> },
                            { path: "gamedevs/", element: <DeveloperScreen screen="gamedevs" /> },
                            { path: "gamedevs/:id/", element: <DeveloperScreen screen="gamedevs" /> },
                        ],
                    },
                ],
            },
            {
                path: "admin/",
                children: [
                    { path: "actionlog/:kind/", element: <ActionLogScreen /> },
                    { path: "actionlog/:kind/:id/", element: <ActionLogScreen /> },
                    { path: "account/", element: <AccountScreen /> },
                    { path: "account/:id/", element: <AccountScreen /> },
                    { path: "gamecenter/logs/", element: <GameCenterScreen screen="logs" /> },
                    {
                        path: "gamecenter/access_test_astrum/",
                        element: <GameCenterScreen screen="access_test_astrum" />,
                    },
                    {
                        path: "gamecenter/access_test_astrum/:id/",
                        element: <GameCenterScreen screen="access_test_astrum" />,
                    },
                    { path: "gamecenter/access_admin/", element: <GameCenterScreen screen="access_admin" /> },
                    { path: "gamecenter/access_admin/:id/", element: <GameCenterScreen screen="access_admin" /> },
                    { path: "tags/", element: <TagScreen /> },
                    { path: "tags/:id/", element: <TagScreen /> },
                    { path: "tags/:id/games/", element: <TagScreen screen="games" /> },
                    { path: "tags/:id/countries/", element: <TagScreen screen="countries" /> },
                    { path: "publisher/", element: <PublisherScreen /> },
                    { path: "publisher/:id/", element: <PublisherScreen /> },
                    { path: "publisher/:id/developers/", element: <PublisherScreen screen="developers" /> },
                    { path: "publisher/:id/games/", element: <PublisherScreen screen="games" /> },
                    { path: "notice/", element: <NoticeScreen /> },
                    { path: "notice/:id/", element: <NoticeScreen /> },
                    {
                        path: "moderation/",
                        children: [
                            { path: "featuring/launch/", element: <BasicPromoModerationScreen /> },
                            { path: "featuring/launch/:id/", element: <BasicPromoModerationScreen /> },
                            { path: "featuring/promo/", element: <FeaturingModerationScreen /> },
                            { path: "featuring/promo/:id/", element: <FeaturingModerationScreen /> },
                            { path: "event/", element: <EventModerationScreen /> },
                            { path: "event/:event_slug/:game_id/", element: <EventModerationScreen /> },
                            { path: "pr/", element: <PrModerationScreen /> },
                            { path: "pr/:developer_id/", element: <PrModerationScreen /> },
                            { path: "project_transfer/:smth/", element: <ProjectTransferModerationScreen /> },
                            { path: "market_serials/", element: <MarketSerialsModerationScreen /> },
                            { path: "market_serials/:id/", element: <MarketSerialsModerationScreen /> },
                            { path: "documents/", element: <DocumentsModerationScreen /> },
                            { path: "documents/:id/", element: <DocumentsModerationScreen /> },
                            { path: "game/", element: <GameModerationScreen /> },
                            { path: "game/:id/", element: <GameModerationScreen /> },
                        ],
                    },
                    { path: "upcoming_releases/", element: <UpcomingReleasesScreen /> },
                    {
                        path: "finstatements/",
                        children: [
                            { path: "month/", element: <FinStatementsScreen screen="month" /> },
                            { path: "payments_control/", element: <FinStatementsScreen screen="payments_control" /> },
                            { path: "dmr/", element: <FinStatementsScreen screen="dmr" /> },
                            { path: "documents/", element: <FinStatementsScreen screen="documents" /> },
                            { path: "royalty/", element: <FinStatementsScreen screen="royalty" /> },
                            { path: "report_cloud/", element: <FinStatementsScreen screen="report_cloud" /> },
                            { path: "report_cloud/:id/", element: <FinStatementsScreen screen="report_cloud" /> },
                            {
                                path: "developer_receipts/",
                                element: <FinStatementsScreen screen="developer_receipts" />,
                            },
                            { path: "merchants/", element: <FinStatementsScreen screen="merchants" /> },
                        ],
                    },
                    { path: "statements/games_report/", element: <GamesReportScreen /> },
                    { path: "statements/developers_report/", element: <DevelopersReportScreen /> },
                    { path: "developers_email/", element: <DevelopersEmailScreen /> },
                    {
                        path: "pockets",
                        children: [
                            { path: "", element: <PocketsReactListScreen /> },
                            { path: ":slug/", element: <PocketsReactListItemsScreen /> },
                            { path: ":slug/:id/", element: <PocketsItemEditScreen /> },
                            { path: ":slug/:id/:locale/", element: <PocketsItemEditScreen /> },
                            { path: "info/:slug/", element: <PocketsInfoEditScreen /> },
                            { path: "info/:slug/:locale/", element: <PocketsInfoEditScreen /> },
                        ],
                    },
                    {
                        path: "event",
                        children: [
                            { path: "", element: <EventListScreen /> },
                            { path: ":slug/", element: <EventSelectionItemListScreen /> },
                            { path: ":slug/:selection_id/landing/", element: <LandingScreen /> },
                            {
                                path: ":slug/:selection_id/landing/add_games/",
                                element: <LandingAddGamesScreen />,
                            },
                            {
                                path: ":slug/:selection_id/landing/:block_id/games/",
                                element: <LandingBlockGamesScreen />,
                            },
                            {
                                path: ":slug/:selection_id/landing/:block_id/settings/",
                                element: <BlockSettingsScreen />,
                            },
                            {
                                path: ":slug/:selection_id/landing/:block_id/settings/:id",
                                element: <BlockSettingsScreen />,
                            },
                            {
                                path: ":slug/:selection_id/landing/:block_id/game/:selection_item_id/",
                                element: <LandingBlockGameEditScreen />,
                            },
                            { path: ":slug/settings/", element: <EventSettingsScreen /> },
                            { path: ":slug/generate_serials/", element: <EventGenerateSerialsScreen /> },
                            { path: ":slug/send_serials/", element: <EventSendSerialsScreen /> },
                            { path: ":slug/send_keys/", element: <EventSettingsScreen /> },
                            { path: ":event_slug/:selection_id/add", element: <EventSelectionItemAddScreen /> },
                            {
                                path: ":event_slug/send_newsletter/",
                                element: <EventSendNewsletterScreen />,
                            },
                            {
                                path: ":event_slug/send_newsletter/:newsletter_id/",
                                element: <EventSendNewsletterScreen />,
                            },
                            {
                                path: ":event_slug/newsletter_history/",
                                element: <EventNewsletterHistoryScreen />,
                            },
                            {
                                path: ":event_slug/newsletter_history/:newsletter_id",
                                element: <EventNewsletterHistoryItemScreen />,
                            },
                            {
                                path: ":event_slug/:selection_slug/:item_id/edit",
                                element: <EventSelectionItemEditScreen />,
                            },
                            {
                                path: ":event_slug/:selection_slug/:item_id/:loc/edit",
                                element: <EventSelectionItemEditScreen />,
                            },
                            { path: "pocket_group/", element: <EventGroupListScreen /> },
                            { path: "field_constructor", element: <SchemeItemListScreen /> },
                            {
                                path: "schemes/",
                                children: [
                                    { path: "", element: <SchemeListScreen /> },
                                    { path: "configuration/", element: <SchemaConfigurationScreen /> },
                                    { path: "configuration/:id/", element: <SchemaConfigurationScreen /> },
                                ],
                            },
                        ],
                    },
                    {
                        path: "landing_ct",
                        children: [
                            { path: "", element: <LandingCTList /> }, // Список лендингов
                            { path: "add/", element: <LandingCTEditScreen /> }, // Добавление лендинга
                            { path: ":item_id/edit/", element: <LandingCTEditScreen /> }, // Редактирование лендинга
                            { path: ":slug/", element: <LandingCTBlockScreen /> }, // Страница с блоками
                            { path: ":slug/:block_id/", element: <LandingCTItemsScreen /> }, // Элементы блока
                            { path: ":slug/:block_id/settings/", element: <LandingCTBlockSettingsScreen /> }, // Поля блока
                            { path: ":slug/:block_id/:item_id/", element: <LandingCTItemEditScreen /> }, // Редактирование блока
                        ],
                    },
                ],
            },
            {
                path: "market/",
                children: [
                    { path: "buka/", element: <MarketBukaScreen /> },
                    { path: "enaza/", element: <MarketEnazaScreen /> },
                    { path: "sales/", element: <MarketSalesScreen /> },
                    { path: "orders/", element: <MarketOrderScreen /> },
                    { path: "foreign_invoice/", element: <MarketForeignInvoiceScreen /> },
                    { path: "steam_gift_order/", element: <MarketSteamGiftOrderScreen /> },
                    { path: "ckassa_blacklist/", element: <CkassaBlacklistScreen /> },
                    { path: "ckassa_blacklist/:id/", element: <CkassaBlacklistScreen /> },
                    { path: "payments/", element: <MarketPaymentsScreen /> },
                    { path: "errors/", element: <MarketErrorScreen /> },
                    { path: "platforms/", element: <MarketPlatformScreen /> },
                    { path: "platforms/:id/", element: <MarketPlatformScreen /> },
                    { path: "promocode/", element: <MarkerPromocodeScreen /> },
                    { path: "promocode/:action/", element: <MarkerPromocodeScreen /> },
                    { path: "serials/", element: <MarketSerialsScreen /> },
                    { path: "merchant_set/", element: <MerchantSetScreen /> },
                ],
            },
            {
                path: "moderate/",
                children: [
                    { path: "comments/", element: <ModerateCommentsScreen /> },
                    { path: "community/", element: <ModerateCommunityScreen /> },
                    { path: "chat/", element: <ModerateChatScreen /> },
                    { path: "profile_posts/", element: <ModerateProfilePostsScreen /> },
                    { path: "microreviews/", element: <ModerateMicroreviewScreen /> },
                    { path: "microreviews/complaints/", element: <ModerateMicroreviewComplaintsScreen /> },
                ],
            },
            {
                path: "games/",
                children: [
                    { path: "", element: <GameListScreen /> },
                    { path: "create/:developerId/", element: <GameCreateScreen screen="create" /> },
                    { path: "create/developer_choose/", element: <GameCreateScreen screen="developer_choose" /> },
                    {
                        id: "gameCommonInfo",
                        path: ":gameId/",
                        loader: gameCommonInfoLoader,
                        children: [
                            { path: "", element: <GameScreen screen="reroute" /> },
                            { path: "admin/", element: <GameScreen screen="admin" /> },
                            { path: "accounts/", element: <GameScreen screen="accounts" /> },
                            { path: "achievements/", element: <GameScreen screen="achievements" /> },
                            { path: "achievements/:id/", element: <GameScreen screen="achievements" /> },
                            { path: "achievements/:id/:locl/", element: <GameScreen screen="achievements" /> },
                            { path: "achievements/:id/addmulti/", element: <GameScreen screen="achievements" /> },
                            { path: "apk_upload/", element: <GameScreen screen="apk_upload" /> },
                            { path: "betatesters/", element: <GameScreen screen="betatesters" /> },
                            {
                                path: "betatesters/upload_list/",
                                element: <GameScreen screen="betatesters_upload_list" />,
                            },
                            { path: "betatesters/:action/", element: <GameScreen screen="betatesters" /> },
                            { path: "stream/", element: <GameScreen screen="stream" /> },
                            { path: "campaigns/:id/", element: <GameScreen screen="campaigns" /> },
                            { path: "serials/", element: <GameScreen screen="serials" /> },
                            { path: "serials/:action/", element: <GameScreen screen="serials" /> },
                            { path: "codes/", element: <GameScreen screen="codes" /> },
                            { path: "codes/:id/", element: <GameScreen screen="codes" /> },
                            { path: "community/", element: <GameScreen screen="community" /> },
                            { path: "community/:id/", element: <GameScreen screen="community" /> },
                            { path: "distributions/", element: <GameScreen screen="distributions" /> },
                            { path: "featuring/launch/", element: <GameScreen screen="featuring_launch" /> },
                            { path: "featuring/promo/", element: <GameScreen screen="featuring_promo" /> },
                            { path: "featuring/promo/:id/", element: <GameScreen screen="featuring_promo" /> },
                            {
                                path: "featuring/event/:event_slug/:newsletter_id/",
                                element: <GameScreen screen="events" />,
                            },
                            { path: "gameitems/", element: <GameScreen screen="gameitems" /> },
                            { path: "gameitems/:itemdefid/", element: <GameScreen screen="gameitems" /> },
                            { path: "locales/:locl/", element: <GameScreen screen="locale_edit" /> }, // Основные свойства
                            { path: "microreviews/", element: <GameScreen screen="microreviews" /> },
                            { path: "microreviews/:id/", element: <GameScreen screen="microreviews" /> },
                            { path: "prices/", element: <GameScreen screen="prices" /> },
                            { path: "playtest/", element: <GameScreen screen="playtest" /> },
                            { path: "playtest/:act/", element: <GameScreen screen="playtest" /> },
                            { path: "publication_moderator/", element: <GameScreen screen="publication_moderator" /> },
                            { path: "publication_developer/", element: <GameScreen screen="publication_developer" /> },
                            { path: "relationship/", element: <GameScreen screen="relationship" /> },
                            { path: "relationship/:rel_type/add/", element: <GameScreen screen="relationship" /> },
                            { path: "s3mirrors/", element: <GameScreen screen="s3mirrors" /> },
                            { path: "highlights/:locl/:id/", element: <GameScreen screen="highlights" /> }, // Добавление скриншотов
                            { path: "highlights/:locl/draft/:id/", element: <GameScreen screen="highlights_draft" /> }, // Добавление черновика скриншота
                            { path: "statistics/orders/", element: <GameScreen screen="statistics_orders" /> },
                            { path: "statistics/payments/", element: <GameScreen screen="statistics_payments" /> },
                            { path: "statistics/sunduki/", element: <GameScreen screen="statistics_sunduki" /> },
                            { path: "statistics/refunds/", element: <GameScreen screen="statistics_refunds" /> },
                            { path: "statistics/wishlist/", element: <GameScreen screen="statistics_wishlist" /> },
                            { path: "statistics/mytracker/", element: <GameScreen screen="statistics_my_tracker" /> },
                            { path: "statistics/general/", element: <GameScreen screen="statistics_general" /> },
                            { path: "statistics/onlines/", element: <GameScreen screen="statistics_onlines" /> },
                            { path: "system/", element: <GameScreen screen="system" /> },
                            { path: "unpublish/", element: <GameScreen screen="unpublish" /> },
                            { path: "moderator_comments/", element: <GameScreen screen="moderator_comments" /> },
                            { path: "gamebox/", element: <GameScreen screen="gamebox" /> },
                        ],
                    },
                ],
            },
        ],
    },
]);
